import { interval, Observable, timer } from 'rxjs';
import { distinctUntilChanged, distinctUntilKeyChanged, filter, map, share, shareReplay, tap } from 'rxjs/operators';
import { RuiterUserDto } from '@api';
import { AuthenticationStorageService } from '@core/authentication/services/authentication-storage.service';
import { MonitoringService } from '@core/services/monitoring.service';
import { Injectable } from '@angular/core';
import { RxjsUtils } from '@app/core';

@Injectable()
export class CurrentUserService {
  private currentUser$ = this.authStorage.user$.pipe(
    filter(RxjsUtils.isNotNullOrUndefined),
    distinctUntilKeyChanged('lastChange'),
    tap((user) => (this.currentUser = user)),
    shareReplay(1)
  );
  private currentUser: RuiterUserDto | null = null;

  constructor(
    private authStorage: AuthenticationStorageService,
    private monitoring: MonitoringService
  ) {
    this.currentUser$.subscribe((user) => this.monitoring.monitorUser(user));
  }

  getCurrentUser(): Observable<RuiterUserDto | null> {
    return this.currentUser$;
  }

  getCurrentUserInstant(): RuiterUserDto | null {
    return this.currentUser;
  }

  getCurrentUserEmail(): Observable<string | null> {
    return this.getCurrentUser().pipe(map((user) => this.getEmailFromUser(user)));
  }

  getCurrentUserEmailInstant(): string | null {
    return this.getEmailFromUser(this.getCurrentUserInstant());
  }

  updateUser(updatedUser: RuiterUserDto): void {
    this.authStorage.updateUser(updatedUser);
  }

  private getEmailFromUser(user: RuiterUserDto | null): string | null {
    const name: string | null = user?.username ?? null;
    return name?.includes('@') ? name : null;
  }
}
